import { Box, Checkbox, Group, Text } from '@mantine/core';
import CircleIcon from '@/icons/circle.svg';
import { NodeCard } from './NodeCard';
import { useImpersonationQuery } from '@/shared/useImpersonationQuery';

type OperationCardProps = {
  name: string;
  description: string;
  onClick?: () => void;
  isSelected: boolean;
  optional?: boolean;
  onEnabledChanged?: (value: boolean) => void;
  isEnabled?: boolean;
};

export function OperationCard({
  name,
  description,
  onClick,
  isSelected,
  onEnabledChanged,
  isEnabled = false,
  optional = false,
}: OperationCardProps) {
  const isHighlighted = !optional ? true : isEnabled ? true : false;
  const { data: impersonation, isFetching } = useImpersonationQuery();

  const isOptional = optional && !isFetching && !impersonation?.isImpersonating;

  return (
    <NodeCard onClick={onClick} w={408} stackProps={{ align: 'flex-start' }} isSelected={isSelected}>
      <Group
        align='flex-start'
        py='xs'
        wrap='nowrap'
        gap='12'
        w='100%'
        px='25'
        flex='0 1'
        style={{ alignItems: 'center' }}
      >
        <Group
          justify='center'
          align='center'
          w={40}
          h={40}
          bg={isHighlighted ? 'var(--mantine-color-teal-0)' : 'var(--mantine-color-gray-0)'}
          style={{ borderRadius: 4, flexShrink: 0 }}
        >
          <CircleIcon
            style={{
              color: isHighlighted ? 'var(--mantine-color-teal-6)' : 'var(--mantine-color-gray-3)',
            }}
          />
        </Group>
        <Group justify={isOptional ? 'space-between' : 'flex-start'} flex='1'>
          <Text fw={600}>{name}</Text>
          {isOptional && <Checkbox checked={isEnabled} onChange={(e) => onEnabledChanged?.(e.target.checked)} />}
        </Group>
      </Group>
      <Box px='md'>
        <Text size='sm' c='gray.6' mah={40} lineClamp={2}>
          {description}
        </Text>
      </Box>
    </NodeCard>
  );
}
